import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';

export default ExpandMoreRoundedIcon;
